const GoogleIconReduced = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.044 14.9021C28.044 13.904 27.9544 12.9443 27.788 12.0229H14.5312V17.4677H22.1066C21.7803 19.2272 20.7886 20.7179 19.2978 21.716V25.2478H23.8468C26.5084 22.7973 28.044 19.1888 28.044 14.9021Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5278 28.6587C18.3283 28.6587 21.5145 27.3983 23.8434 25.2485L19.2944 21.7168C18.034 22.5613 16.4216 23.0604 14.5278 23.0604C10.8617 23.0604 7.75866 20.5843 6.6518 17.2573H1.94922V20.9042C4.26532 25.5044 9.02548 28.6587 14.5278 28.6587Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.65285 17.2574C6.37134 16.4129 6.21139 15.5107 6.21139 14.583C6.21139 13.6553 6.37134 12.7532 6.65285 11.9086V8.26172H1.95027C0.996961 10.1619 0.453125 12.3117 0.453125 14.583C0.453125 16.8543 0.996961 19.0041 1.95027 20.9043L6.65285 17.2574Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5278 6.10466C16.5944 6.10466 18.4498 6.81484 19.9086 8.20962L23.9458 4.17244C21.5081 1.90113 18.3219 0.506348 14.5278 0.506348C9.02548 0.506348 4.26532 3.66059 1.94922 8.26081L6.6518 11.9077C7.75866 8.58071 10.8617 6.10466 14.5278 6.10466Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default GoogleIconReduced;
